import { APIPropertyFunction } from '@mygpt/app/functions/services/list';
import { Http } from '@mygpt/app/http';

export interface RunApiParamsFunction extends APIPropertyFunction {
  // 数据集 ID
  datasetId: string;
  question: string;
}

export interface RunApiResponseFunction {
  function_call_sta: boolean;
  ask_content: {
    answer: string;
    messages: string[];
  };
  keywords: string;
  send_info: {
    method: string;
  };
}

/**
 * 添加API
 * @param params
 * @returns
 */
export const runApiServiceFunction = (params: RunApiParamsFunction) => {
  const { datasetId, question, ...rest } = params;
  const { post } = Http.use();
  return post<RunApiResponseFunction>(`/datasets/${datasetId}/functions/run`, rest, {
    params: {
      question,
    },
  });
};
